<template>
  <div
    class="sidearm-mm-social bg-primary text-on-primary overflow-hidden"
    data-anchor="social"
  >
    <section-background css_var="--section-desktop-bg-social"></section-background>
    <video-background
      v-if="section.background_type === 'video'"
      :video="section.background_video"
    />

    <div
      class="sidearm-mm-social__section-connector absolute flex flex-column flex-align-center"
    >
      <span></span>
    </div>

    <div class="sidearm-mm-social__inner flex flex-align-center h-100 relative">
      <background-element
        class="sidearm-mm-social__left-bg col-1-of-8 large-col-2-of-8 h-100 absolute"
      />
      <background-element
        class="sidearm-mm-social__right-bg col-1-of-8 large-col-2-of-8 h-25 absolute"
      />

      <div
        class="sidearm-mm-social__details col-6-of-8 x-large-col-3-of-8 col-push-1 relative"
        :class="{
          'text-white': has_background_image
        }"
      >
        <div
          v-if="section.hashtag"
          class="sidearm-mm-social__hashtag type-hero"
        >
          #{{ section.hashtag }}
        </div>

        <ul
          class="sidearm-mm-social__links reset flex flex-align-center flex-wrap"
        >
          <li v-for="link in social_links" :key="link.title" class="mr-2 mb-2">
            <a
              :href="link.url"
              target="_blank"
              class="sidearm-mm-btn --primary-alt"
            >
              <icon class="hide-on-large" size="1.5rem">{{ link.icon }}</icon>
              <span class="hide-on-medium-down">{{ link.title }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div
        class="sidearm-mm-social__player col-8-of-8 large-col-4-of-8 x-large-col-3-of-8 h-100 relative overflow-hidden"
      >
        <img
          v-if="random_player_cutout && !section.hide_cutout"
          :src="
            `${$root.absolutize_cdn(
              random_player_cutout.url
            )}?width=720&height=960&quality=80`
          "
          :alt="random_player_cutout.alt_text"
          class="sidearm-mm-social__player-cutout absolute w-auto h-auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  components: {
    BackgroundElement
  },

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }

      return this.$root.data.social_section;
    },

    social_links() {
      if (!this.section) {
        return [];
      }

      return this.section.links.filter(link => link.enabled);
    },

    random_player_cutout() {
      if (!this.$root.data) {
        return null;
      }

      const players_with_cutouts = this.$root.data.roster.filter(
        player => player.cutout_image
      );

      if (!players_with_cutouts.length) {
        return null;
      }

      const random_index = Math.floor(
        Math.random() * players_with_cutouts.length
      );

      return players_with_cutouts[random_index].cutout_image;
    },
    has_background_image() {
      if (window.matchMedia("(min-width:1025px)").matches) {
        return this.section.background_image_desktop;
      } else {
        return (
          this.section.background_image_desktop ||
          this.section.background_image_mobile
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-social {

  &__inner {
    padding-top: $header-height;
  }

  &__section-connector {
    top: 0;
    left: calc(62.5% - 0.75rem);
    z-index: 1;

    &::before {
      background-color: $color-white;
      content: "";
      display: block;
      height: $header-height + $spacer * 3;
      width: 1px;
    }

    > button {
      @include base-reset();

      border: 1px solid $color-white;
      border-radius: 50%;
      height: 1.5rem;
      transition: 0.35s;
      width: 1.5rem;

      &:hover {
        background-color: $color-white;
      }
    }
  }

  &__details {
    z-index: 1;
  }

  &__hashtag {
    white-space: nowrap;
  }

  &__links {
    margin-top: $spacer * 6;
  }

  &__player-cutout {
    bottom: 0;
    left: 0;
    max-height: 95%;
  }

  &__left-bg {
    left: 25%;
    top: $header-height;
  }

  &__right-bg {
    right: 0;
    top: calc(25% + #{$header-height});
  }

  @media (max-width: 1159px) {
    &__player-cutout {
      opacity: 0.55;
      filter: grayscale(1);
    }
  }

  @media (max-width: #{$breakpoint-x-large}) {
    background-size: cover;
    &__section-connector {
      left: 50%;
      transform: translateX(-50%);
    }

    &__left-bg {
      height: 50%;
      left: 0;
      top: 50%;
    }

    &__right-bg {
      left: 37.5%;
      top: 0;
    }

    &__hashtag {
      white-space: normal;
    }

    &__player {
      position: absolute !important;
      right: 0;
      bottom: 0;
    }
  }

  @media (max-width: #{$breakpoint-large}) {
    &__player {
      right: -25%;
    }

    &__links {
      a {
        padding: $spacer !important;
      }
    }
  }
  @media (max-width: #{$breakpoint-medium}) {
    .type-hero {
      font-size: 2.25rem;
    }
  }
}
</style>
